import type { FormDefinition, FormVersion } from '@fulcrum/form-embedded';
import { PHQ9_DOCUMENT } from './demo/phq9';
import { GAD7_DOCUMENT } from './demo/gad7';

const NOW = new Date().toISOString();

export const SEED_DEFINITIONS: FormDefinition[] = [
  {
    formId: 'phq9',
    name: 'PHQ-9 Depression Screener',
    description: 'Patient Health Questionnaire — 9 item depression severity screener.',
    formType: 'screener',
    isActive: true,
    isLocked: false,
    flags: { showIntake: true },
    activeVersionId: 'phq9-v1',
    createdAt: NOW,
  },
  {
    formId: 'gad7',
    name: 'GAD-7 Anxiety Screener',
    description: 'Generalized Anxiety Disorder — 7 item severity screener.',
    formType: 'screener',
    isActive: true,
    isLocked: false,
    flags: { showIntake: true },
    activeVersionId: 'gad7-v1',
    createdAt: NOW,
  },
  {
    formId: 'intake-adult',
    name: 'Adult Intake Assessment',
    description: 'Comprehensive intake form for adult clients including demographics, presenting issues, and history.',
    formType: 'intake',
    isActive: true,
    isLocked: false,
    flags: { showIntake: true },
    activeVersionId: 'intake-adult-v1',
    createdAt: NOW,
  },
  {
    formId: 'safety-plan',
    name: 'Safety Planning Form',
    description: 'Collaborative safety plan identifying warning signs, coping strategies, and crisis contacts.',
    formType: 'treatment',
    isActive: true,
    isLocked: false,
    flags: {},
    activeVersionId: 'safety-plan-v1',
    createdAt: NOW,
  },
  {
    formId: 'discharge-summary',
    name: 'Discharge Summary',
    description: 'Summarizes treatment goals, progress, and aftercare recommendations at discharge.',
    formType: 'discharge',
    isActive: false,
    isLocked: true,
    flags: {},
    activeVersionId: 'discharge-summary-v1',
    createdAt: NOW,
  },
  {
    formId: 'columbia-scale',
    name: 'Columbia Suicide Severity Rating Scale',
    description: 'Standardized assessment of suicidal ideation and behavior severity.',
    formType: 'screener',
    isActive: true,
    isLocked: false,
    flags: { showIntake: true },
    activeVersionId: 'columbia-scale-v1',
    createdAt: NOW,
  },
  {
    formId: 'progress-note',
    name: 'Progress Note Template',
    description: 'Session progress note covering subjective, objective, assessment, and plan sections.',
    formType: 'note',
    isActive: true,
    isLocked: false,
    flags: {},
    activeVersionId: 'progress-note-v1',
    createdAt: NOW,
  },
];

export const SEED_VERSIONS: FormVersion[] = [
  {
    formVersionId: 'phq9-v1',
    formId: 'phq9',
    versionNumber: 1,
    status: 'published',
    document: PHQ9_DOCUMENT,
    createdAt: NOW,
    createdBy: 'seed',
  },
  {
    formVersionId: 'gad7-v1',
    formId: 'gad7',
    versionNumber: 1,
    status: 'published',
    document: GAD7_DOCUMENT,
    createdAt: NOW,
    createdBy: 'seed',
  },
  {
    formVersionId: 'intake-adult-v1',
    formId: 'intake-adult',
    versionNumber: 1,
    status: 'published',
    document: { sections: [] },
    createdAt: NOW,
    createdBy: 'seed',
  },
  {
    formVersionId: 'safety-plan-v1',
    formId: 'safety-plan',
    versionNumber: 1,
    status: 'published',
    document: { sections: [] },
    createdAt: NOW,
    createdBy: 'seed',
  },
  {
    formVersionId: 'discharge-summary-v1',
    formId: 'discharge-summary',
    versionNumber: 1,
    status: 'published',
    document: { sections: [] },
    createdAt: NOW,
    createdBy: 'seed',
  },
  {
    formVersionId: 'columbia-scale-v1',
    formId: 'columbia-scale',
    versionNumber: 1,
    status: 'published',
    document: { sections: [] },
    createdAt: NOW,
    createdBy: 'seed',
  },
  {
    formVersionId: 'progress-note-v1',
    formId: 'progress-note',
    versionNumber: 1,
    status: 'published',
    document: { sections: [] },
    createdAt: NOW,
    createdBy: 'seed',
  },
];
